import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from '../general-catalog-select.service';

export interface TypeOfTaxSelectOption {
  value: string;
  label: string;
  code?: string;
}

/** Catálogo `tax_types` vía select unificado. */
@Injectable({ providedIn: 'root' })
export class TypeOfTaxSelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<TypeOfTaxSelectOption[]> {
    return this.generalCatalogSelect.getListOptionsByPrefix('tax_types').pipe(
      map((options) =>
        options.map((o) => ({
          value: o.value,
          label: o.label,
          code: o.code || '',
        })),
      ),
    );
  }
}
